export const PIXEL_RATIO = window.devicePixelRatio || 1
export const VIEWPORT_RATIO = 0.98
